package com.royceecoleman.bill.shared.billing

import kotlinx.serialization.Serializable

/** A PDF or Word (.docx) document of a previous month's final bill, as produced by the lawyer's billing software. The file itself is not kept. */
@Serializable
data class PreviousBillUpload(
    val filename: String,
    val contentBase64: String,
)

/** One fee entry read from a previous bill. The narrative is verbatim; the other fields are blank when the bill omits them. */
@Serializable
data class PreviousBillEntry(
    val narrative: String,
    /** YYYY-MM-DD. Shown to the lawyer only, never sent to the drafting model. */
    val date: String = "",
    /** Billed hours as written, such as "1.2". */
    val hours: String = "",
    val taskCode: String = "",
    val activityCode: String = "",
)

@Serializable
data class PreviousBill(
    val id: String,
    val filename: String,
    val uploadedAt: Long,
    val entryCount: Int,
    /** In the order they appear on the bill. */
    val entries: List<PreviousBillEntry> = emptyList(),
) {
    companion object {
        const val MAX_PER_PROFILE = 6

        /** For previous bills and standing-rules uploads alike. */
        const val MAX_FILE_BYTES = 20_971_520
        const val MAX_PAGES = 100
    }
}
